import { cn } from '@/lib/utils';

interface SkeletonProps {
  width?: string;
  height?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'full';
  className?: string;
}

const roundedMap = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  full: 'rounded-full',
};

export default function Skeleton({
  width,
  height,
  rounded = 'md',
  className,
}: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse bg-surface-muted',
        roundedMap[rounded],
        className
      )}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}
